import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function DevicePieChart({ data }) {
  // Color scheme: Mobile (blue), Tablet (purple), Desktop (green)
  const COLORS = ['#3B82F6', '#8B5CF6', '#10B981'];
  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie 
          data={data} 
          dataKey="count" 
          nameKey="device" 
          cx="50%" cy="50%" 
          outerRadius={80} 
          innerRadius={40} 
          paddingAngle={2}
        >
          {data.map((entry, index) => (
            <Cell key={`device-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default DevicePieChart;

